import styled from 'styled-components'
import { green, danger, blackOrange, white, border1 } from '@/theme/colors'
import { radii, media } from '@/theme/tokens'
import { text } from '@/theme/typography'

// The Activity panel renders the shared Balances ActivityFeed — its styles live
// in ActivitySection.styles; this file only styles the public-specific frame.

/** Two-column money view that stacks on narrow screens (unlike the member split, which hides). */
export const ExpensesLayout = styled.div`
	display: grid;
	grid-template-columns: minmax(0, 360px) minmax(0, 1fr);
	gap: 20px;
	align-items: start;

	${media.tabletWide} {
		grid-template-columns: 1fr;
	}
`

export const Panel = styled.section`
	background: ${white};
	border: 1px solid ${border1};
	border-radius: ${radii.card};
	padding: 18px 18px 22px;
`

export const PanelTitle = styled.h2`
	${text.title}
	color: ${blackOrange};
	margin: 0 0 14px;
`

export const BalanceRow = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	padding: 10px 0;
	border-bottom: 1px solid ${border1};

	&:last-child {
		border-bottom: none;
	}
`

export const BalanceName = styled.span`
	flex: 1;
	min-width: 0;
	${text.bodySm}
	color: ${blackOrange};
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`

export const BalanceAmount = styled.span<{ $tone: 'owe' | 'owed' }>`
	${text.labelSm}
	white-space: nowrap;
	color: ${({ $tone }) => ($tone === 'owed' ? green : danger)};
`

export const SettledNote = styled.div`
	${text.bodyXs}
	color: ${green};
	padding: 8px 0;
`
